module.exports = __webpack_public_path__ + "img/dl_image.68f68f4d.gif";